import { DescriptionsProps } from 'antd/es/descriptions';

export const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export const ChineseYuan = new Intl.NumberFormat('zh-CN', {
    style: 'currency',
    currency: 'CNY',
});

export const USD_TO_CNY = 7.15;

export function formatCurrency(amount: number | undefined, unit: string) {
    if (!amount) amount = 0;
    if (unit.toLowerCase() === 'usd') {
        return USDollar.format(amount);
    } else if (unit.toLowerCase() === 'cny') {
        return ChineseYuan.format(amount);
    }
}

// Sum all same money field of positions convert all to usd
export function sumAllFormatUSD(positions: Array<any>, field: string) {
    return USDollar.format(
        positions.reduce((acc, cur) => {
            const amount =
                cur.currency.toLowerCase() === 'cny'
                    ? cur[field] / USD_TO_CNY
                    : cur[field];
            return acc + amount;
        }, 0)
    );
}

// extract usd positions and take sum
export function sumUSDFormat(positions: Array<any>, field: string) {
    return USDollar.format(
        positions
            .filter((position) => position.currency.toLowerCase() === 'usd')
            .reduce((acc, cur) => {
                const amount = cur[field];
                return acc + amount;
            }, 0)
    );
}

// extract cny positions and take sum
export function sumCNYFormat(positions: Array<any>, field: string) {
    return ChineseYuan.format(
        positions
            .filter((position) => position.currency.toLowerCase() === 'cny')
            .reduce((acc, cur) => {
                const amount = cur[field];
                return acc + amount;
            }, 0)
    );
}

export const makeDescriptionItems = (
    infoKeyNameMap: Record<string, string>,
    data: Record<string, any>,
    keyConfig?: Record<string, string>
) =>
    Object.keys(infoKeyNameMap)
        .filter((key) => key in data)
        .map((key) => {
            return {
                key,
                label: infoKeyNameMap[key],
                children: data[key] || '-',
            };
        });

export const makeTableDataSource = (
    infoKeyNameMap: Record<string, string>,
    data: Record<string, any>,
    keyConfig?: Record<string, string>
) =>
    Object.keys(infoKeyNameMap)
        .filter((key) => key in data)
        .map((key) => {
            // if (key in keyConfig) {

            // }
            return {
                key,
                name: infoKeyNameMap[key],
                value: data[key] || '-',
            };
        });

export const makeColumns = (nameTitle: string, valueTitle: string) => [
    {
        title: nameTitle,
        dataIndex: 'name',
    },
    {
        title: valueTitle,
        dataIndex: 'value',
    },
];

export function toTitleCase(str: string) {
    const lowercaseWords = new Set([
        'a',
        'an',
        'and',
        'as',
        'at',
        'but',
        'by',
        'for',
        'in',
        'nor',
        'of',
        'on',
        'or',
        'so',
        'the',
        'to',
        'up',
        'yet',
        'with',
    ]);
    return str
        .toLowerCase()
        .split(' ')
        .map((word, index) => {
            // Always capitalize the first word
            if (index === 0 || !lowercaseWords.has(word)) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }
            return word;
        })
        .join(' ');
}

export function parsePgArray(str: string | null) {
    if (!str) return [];
    // Remove the outer curly braces
    const trimmed = str.slice(1, -1);

    // Use a regex to match quoted or unquoted values
    const regex = /"([^"]+)"|([^,]+)/g;
    const result = [];
    let match;

    while ((match = regex.exec(trimmed)) !== null) {
        result.push(match[1] || match[2]);
    }

    return result;
}

export function displayBoolean(bool: boolean | null) {
    if (bool === null) {
        return '';
    }
    return bool ? 'Yes' : 'No';
}
